<template>
  <v-container fluid>
    <v-card class="elevation-10">
      <v-skeleton-loader
        :loading="loading"
        type="table-heading, table-thead, table-row-divider@12, table-tfoot"
      >
        <v-card-actions>
          <v-row>
            <v-col
              cols="4"
              md="3"
              xl="4"
            >
              <v-toolbar
                flat
              >
                <v-toolbar-title class="md-4  white--text">
                  Fund Bucket Items
                </v-toolbar-title>
              </v-toolbar>
            </v-col>
            <v-col
              cols="4"
              md="3"
              xl="4"
            >
              <v-text-field
                v-model="search"
                placeholder="Search"
                append-icon="fa fa-search"
                label="Search Fund Bucket Item"
                hide-no-data
                hide-selected
                clearable
              />
            </v-col>
            <v-col
              cols="2"
              md="3"
              xl="2"
              class="mt-2"
            />
            <v-col
              cols="2"
              md="3"
              xl="2"
              class="mt-2 text-right"
            >
              <bucket-fund-bucket-item-dialog-edit-priority
                @updated="loadData"
              />
              <bucket-fund-bucket-item-dialog-mass-edit
                @updated="loadData"
              />
              <bucket-fund-bucket-item-dialog-create
                @created="loadData"
              />
              <span style="margin:9px" />
            </v-col>
          </v-row>
        </v-card-actions>

        <v-data-table
          dense
          :headers="headers"
          multi-sort
          :items="fundBucketItems"
          :footer-props="{
            'items-per-page-options': [10, 15, 20]
          }"
          :items-per-page="15"
          class="scrollable-table elevation-10"
          :search="search"
          data-simplebar
        >
          <template v-slot:[`item.schemaName`]="{ item }">
            <div>
              <span v-if="item.schemaName">
                {{ item.schemaName }}
              </span>
              <span v-else>
                N/A
              </span>
            </div>
          </template>
          <template v-slot:[`item.fundBucket`]="{ item }">
            <div>
              <span>
                {{ item.name }}
              </span>
            </div>
          </template>
          <template v-slot:[`item.fund_bucket_item_descriptions`]="{ item }">
            <div>
              <span>
                {{ item.description }}
              </span>
            </div>
          </template>
          <template v-slot:[`item.company`]="{ item }">
            <div>
              <span>
                {{ item.name }}
              </span>
            </div>
          </template>
          <template v-slot:[`item.min`]="{ item }">
            <div>
              <span>
                {{ ((item.min).toLocaleString('en-MY', { style: 'currency', currency: 'MYR'})).substring(3) }}
              </span>
            </div>
          </template> 
          <template v-slot:[`item.max`]="{ item }">
            <div>
              <span>
                {{ ((item.max).toLocaleString('en-MY', { style: 'currency', currency: 'MYR'})).substring(3) }}
              </span>
            </div>
          </template>  
          <template v-slot:[`item.multiple_of`]="{ item }">
            <div>
              <span>
                {{ item.multiple_of }}
              </span>
            </div>
          </template> 
          <template v-slot:[`item.priority`]="{ item }">
            <div>
              <span>
                {{ item.priority }}
              </span>
            </div>
          </template> 
          <template v-slot:[`item.is_valid`]="{ item }">
            <v-icon
              v-if="item.is_valid"
              medium
              color="green"
            >
              mdi-check
            </v-icon>
            <v-icon
              v-else
              medium
              color="red"
            >
              mdi-close
            </v-icon>
          </template> 
          <template v-slot:[`item.has_quota`]="{ item }">
            <v-icon
              v-if="item.has_quota"
              medium
              color="green"
            >
              mdi-check
            </v-icon>
            <v-icon
              v-else
              medium
              color="red"
            >
              mdi-close
            </v-icon>
          </template> 

          <template v-slot:[`item.action`]="{ item }">
            <bucket-fund-bucket-item-dialog-edit
              :item="item"
              @updated="loadData"
            />
            <bucket-fund-bucket-item-dialog-delete
              :fund-bucket-item="item"
              @deleted="loadData"
            />
          </template>
        </v-data-table>
      </v-skeleton-loader>
    </v-card>

    <v-snackbar
      v-model="snack"
      bottom
      :color="snackColor"
      class="center-snackbar"
    >
      {{ snackText }}
    </v-snackbar>
  </v-container>
</template>

<script>
  export default {
    data () {
      return {
        loading: true,
        search: '',
        snackColor: '',
        snack: '',
        snackText: '',
        headers: [
          { text: 'Schema', value: 'schemaName', align: 'left' },
          { text: 'Bucket', value: 'fund_bucket.name', align: 'left' },
          { text: 'Bucket Description', value: 'fund_bucket_item_descriptions.description', align: 'left' },
          { text: 'Company', value: 'company.name', align: 'left' },
          { text: 'Min (RM)', value: 'min', align: 'right' },
          { text: 'Max (RM)', value: 'max', align: 'right' },
          { text: 'Multiple of', value: 'multiple_of', align: 'center' },
          { text: 'Priority', value: 'priority', align: 'center' },
          { text: 'Valid', value: 'is_valid', sortable: false, align: 'center' },
          { text: 'Quota', value: 'has_quota', sortable: false, align: 'center' },
          { text: 'Action', value: 'action', align: 'center', sortable: false },
        ],
        fundBucketItems: [],
      }
    },
        
    created () {
      this.loadData()
    },

    methods: {
      deleteFundBucketItem (item) {
        const config = {
          headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
        }

        this.$axios.delete(this.$base_url + '/fundBucketItem/' + item.id, config)
          .then(response => {
            if (response.status === 200) {
              this.loadData()
              this.message('success', response.data.message)
            } else {
              this.message('error', response.data.message)
            }
          })
          .catch(function (error) {
            console.log(error)
          })
      },

      message (color, message) {
        this.snack = true
        this.snackColor = color
        this.snackText = message
      },

      loadData () {
        this.loading = true
        this.$api.fundBucketItems().list()
          .then(response => {
            this.fundBucketItems = response.data.map(function (fundBucketItem) {
              if (fundBucketItem.fund_bucket.fund_bucket_has_types.length > 0) {
                fundBucketItem.schemaName = fundBucketItem.fund_bucket.fund_bucket_has_types[0].schema_name
              }
              return fundBucketItem
            })
            this.loading = false
          })
          .catch(err => {
            console.log(err)
          })
      },
    },
  }
</script>

<style scoped>
    .center-snackbar .v-snack__wrapper .v-snack__content{
        margin:auto !important;
        width:unset !important;
    }
</style>
